export const HEADER_LEN = 8;
export const MAGIC = [0xdd, 0xcc, 0xbb, 0xaa];
export const MAX_RUN = 257;

export class XyRleError extends Error {
  constructor(message) {
    super(message);
    this.name = "XyRleError";
  }
}

export function decodeRle(bytes, start = 0, end = bytes.length) {
  const out = [];
  let previous = -1;

  for (let i = start; i < end; i += 1) {
    const byte = bytes[i];
    out.push(byte);

    if (byte === previous) {
      if (i + 1 >= end) {
        throw new XyRleError(`RLE extension byte needed past end at ${i + 1}`);
      }
      const extension = bytes[i + 1];
      i += 1;
      for (let n = 0; n < extension; n += 1) {
        out.push(byte);
      }
      previous = -1;
    } else {
      previous = byte;
    }
  }

  return new Uint8Array(out);
}

export function encodeRle(bytes) {
  const out = [];
  let i = 0;

  while (i < bytes.length) {
    const value = bytes[i];
    let j = i;
    while (j < bytes.length && bytes[j] === value) {
      j += 1;
    }

    let runLength = j - i;
    while (runLength >= 2) {
      const chunk = Math.min(runLength, MAX_RUN);
      out.push(value, value, chunk - 2);
      runLength -= chunk;
    }
    if (runLength === 1) {
      out.push(value);
    }

    i = j;
  }

  return new Uint8Array(out);
}

export function decodeProject(fileBytes) {
  if (fileBytes.length < HEADER_LEN || !MAGIC.every((b, i) => fileBytes[i] === b)) {
    throw new XyRleError("Not an OP-XY .xy file: missing dd cc bb aa magic.");
  }

  return {
    header: fileBytes.slice(0, HEADER_LEN),
    image: decodeRle(fileBytes, HEADER_LEN),
  };
}

export function encodeProject(header, image) {
  if (header.length !== HEADER_LEN || !MAGIC.every((b, i) => header[i] === b)) {
    throw new XyRleError("Cannot encode .xy file without the original 8-byte header.");
  }

  const encoded = encodeRle(image);
  const out = new Uint8Array(header.length + encoded.length);
  out.set(header, 0);
  out.set(encoded, header.length);
  return out;
}
